// extracted by mini-css-extract-plugin
export default {"wrapper":"InstagramFeed_wrapper__P5EdX"};